import { configure } from "@smartsuite/flash-notifications";
import { RawIntlProvider } from "react-intl";
import { QueryClientProvider } from "react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { FormNotFoundMessage } from "./components/FormNotFoundMessage/FormNotFoundMessage";
import { PageContentBox } from "./components/PageContentBox/PageContentBox";
import { PageLayout } from "./components/PageLayout/PageLayout";
import { defaultLogoUrl } from "./helpers/defaultUrls";
import { FormDebugPage } from "./pages/FormDebugPage/FormDebugPage";
import { FormPageRoute, InternalFormPageRoute } from "./pages/FormPage/FormPage";
import { queryClient } from "./queryClient";
import { intl } from "./utils/intl";
import "./utils/env";

configure();

export const App: React.FC = () => {
  return (
    <RawIntlProvider value={intl}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <PageLayout>
            <Routes>
              {process.env.NODE_ENV === "development" && (
                <Route path="debug" element={<FormDebugPage />} />
              )}
              <Route
                path="/form/:accountId/internal/:reportId"
                element={<InternalFormPageRoute />}
              />
              <Route path="/form/:accountId/:hash" element={<FormPageRoute />} />
              <Route path=":accountId/:hash" element={<FormPageRoute />} />
              <Route
                path="*"
                element={
                  <PageContentBox logoUrl={defaultLogoUrl} displayBranding={true}>
                    <FormNotFoundMessage />
                  </PageContentBox>
                }
              />
            </Routes>
          </PageLayout>
        </BrowserRouter>
      </QueryClientProvider>
    </RawIntlProvider>
  );
};
